import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";
import StepWizard from "react-step-wizard";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";

import moment from "moment";

import ContractTable from "../Contract/List/Modify.js";

import ContractComponent from "../Contract/List/Component.js";

const ModifyContractModal = ({ branchId, nurseryId, bizApp, serviceAppList, appAuthTypeList, nurseryName, list, seasonInfo, directorName, address, showModal, isRecontractModal = false, disabled = false, onDetail, reloadData }) => {
    const [show, setShow] = useState(showModal || false);
    const [bizAppMap, setBizAppMap] = useState(false);
    const [contractList, setContractList] = useState(false);
    useEffect(() => {
        setShow(showModal);
        if (showModal) {
            initModal(bizApp, list ? JSON.parse(JSON.stringify(list)) : list);
        }
        return () => {};
    }, [branchId, nurseryId, bizApp, nurseryName, list, showModal]);
    const initModal = (bizApp, list) => {
        if (bizApp && list) {
            const newBizAppMap = ContractComponent.func.getBizAppMap(bizApp, onChangeBizAppFold);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            setContractList(list);
            updateContractTotal(newBizAppMap, list);
        }
    };
    const updateContractTotal = (bizAppMap, list) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            Object.keys(bizAppMap).forEach((a) => {
                if(a != 'totalInfo') {
                    newBizAppMap[a].count = 0;
                    newBizAppMap[a].quantity = 0;
                }
            });
            newBizAppMap['totalInfo'] = { quantity: 0 };
            list.forEach((c) => {
                if (c.is555) return;
                let quantityTotalAdded = false;
                Object.keys(bizAppMap).forEach((a) => {
                    if (bizAppMap[a].info && c.app_auth[a] && c[bizAppMap[a].info.quantity.field[0]] && (c.app_auth[a].approval === "AP" || c.app_auth[a].approval === "WT")) {
                        newBizAppMap[a].count++;
                        if(bizAppMap[a].hasCellQuantity) {
                            newBizAppMap[a].quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                        } else {
                            if(!quantityTotalAdded) {
                                newBizAppMap.totalInfo.quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                                quantityTotalAdded = true;
                            }
                        }
                    }
                });
            });
            setBizAppMap(newBizAppMap);
        }
    };
    const updateContractList = (list) => {
        setContractList(list);
        updateContractTotal(bizAppMap, list);
    };
    const onChangeBizAppFold = (app, bizApp, fold = undefined) => {
        let newBizAppMap = { ...bizApp };
        newBizAppMap[app].fold = fold == undefined ? !newBizAppMap[app].fold : fold;
        setBizAppMap(newBizAppMap);
    };

    const submitContract = (_list) => {
        let containRecontract = false;
        _list.forEach((c) => {
            if (c.app_auth) {
                Object.keys(bizAppMap).forEach((a) => {
                    if (c.app_auth[a] && c.app_auth[a].approval == "AP" && c.app_auth[a].recontract) {
                        c.app_auth[a].end_date = c.app_auth[a].recontract;
                        containRecontract = true;
                    }
                });
            }
        });
        let isValidate = true;
        let isValidateDevice = true;
        _list.forEach((c) => {
            const auth = c.app_auth;
            Object.keys(bizAppMap).forEach((a) => {
                if (auth[a] && (auth[a].approval === "AP" || auth[a].approval === "WT") && (!c[bizAppMap[a].info.quantity.field[0]] || c[bizAppMap[a].info.quantity.field[0]] <= 0)) {
                    isValidate = false;
                }
            });
            c.app_auth = auth;
            if(!c.device) isValidateDevice = false;
        });
        if (!isValidate) {
            alert("계약을 수정하는 반의 사용 원아 수를 입력해 주세요.");
            return;
        }
        if (!isValidateDevice) {
            alert("계약을 수정하는 반의 디바이스를 선택해 주세요.");
            return;
        }

        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/contract/update/${branchId}/${nurseryId}`,
            data: {
                contracts: _list,
            },
        })
            .then((res) => {
                if (res.data.code === 200) {
                    if (containRecontract) {
                        if (isRecontractModal) {
                            if (window.confirm(`재계약 처리 및 변경 내용이 적용 되었습니다.\n\n창을 닫고 원 관리 페이지로 이동하시겠습니까?`)) {
                                document.location.href = "./contract?type=view&id=" + nurseryId;
                                onDetail(nurseryId, false);
                            } else {
                                reloadData();
                            }
                        } else {
                            alert("재계약 처리 및 변경 내용이 적용 되었습니다.");
                            document.location.reload();
                        }
                    } else {
                        alert("변경 내용이 적용 되었습니다.");
                        document.location.reload();
                    }
                } else if (res.data.code === 5001) {
                    const arr = res.data.exist_apps;
                    const names = [];
                    arr.forEach((a) => {
                        let name = "";
                        const sa = serviceAppList.find((sa) => sa.appId == a);
                        if(sa) {
                            name = sa.name;
                        }
                        if (name) names.push(name);
                    });

                    alert(`해당 원에는 이미 [${names.join(", ")}] 계약이 존재하여 계약을 등록 할 수 없습니다.`);
                    return;
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    return;
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }

    return (
        <>
            <button
                className="btn btn-rounded btn-warning btn-block"
                onClick={() => {
                    initModal(bizApp, list ? JSON.parse(JSON.stringify(list)) : list);
                    setShow(true);
                }}
                disabled={disabled}
            >
                <i className="fas fa-check-circle mr-2" />
                계약 수정
            </button>
            <Modal
                className={`modal-contract modal-container fullscreen-modal`}
                show={show}
                onHide={() => {
                    if (window.confirm("계약 수정을 취소하시겠습니까?")) {
                        setShow(false);
                        // document.location.reload();
                    }
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">{`${isRecontractModal ? "재계약 처리" : "계약 수정"}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="row m-0 bg-primary-light">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header ml-2 mt-3 mb-3">
                                <h3 className="">
                                    {nurseryName}
                                    <span className="text-muted">{` (${directorName || "-"}, ${address || "-"})`}</span>
                                </h3>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" />
                    </div>
                    <div className="row m-0">
                        <div className="col">
                            {isRecontractModal && (
                                <RecontractStep
                                    bizApp={bizAppMap}
                                    serviceAppList={serviceAppList}
                                    appAuthTypeList={appAuthTypeList}
                                    list={contractList}
                                    setList={updateContractList}
                                    seasonInfo={seasonInfo}
                                    isRecontractModal={isRecontractModal}
                                    submitContract={() => submitContract(contractList)}
                                />
                            )}
                            {!isRecontractModal && (
                                <div className="row mt-3 mb-3">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        현재 계약 내용을 확인하시고 승인된 계정 및 상품에 한해 수정할 내용을 변경 후, [저장] 버튼을 눌러 주시기 바랍니다.
                                        <ul>
                                            <li>
                                                신규 계약 등록은 해당 화면에서 불가능합니다. 계약 추가 기능을 이용해 주세요.
                                            </li>
                                            {seasonInfo && seasonInfo.isRecontractSeason && (
                                                <>
                                                    <li>
                                                        <strong className="text-success">{seasonInfo.recontractYear}년 신규</strong>(
                                                        <strong className="text-success">{seasonInfo.recontractYear - 1}년 6월 이후 계약</strong>) 계약을 제외한 기존 계약에 대해 본
                                                        화면에서 재계약을 진행할 수 있습니다. 재계약에 체크 후 저장 버튼을 눌러 주세요.
                                                    </li>
                                                    <li>
                                                        <strong className="text-danger">~ {moment(seasonInfo.recontractEnd).format("YYYY년 MM월 DD일")}</strong>까지 재계약 처리가 되지 않으면
                                                        서비스 이용이 자동 중단되오니, 해당 기간 안에 재계약 처리를 반드시 진행하시기 바랍니다.
                                                    </li>
                                                </>
                                            )}
                                            {seasonInfo && seasonInfo.isNoContractSeason && (
                                                <li>
                                                    <span className="text-danger">
                                                        {moment(seasonInfo.noContractStart).format("MM/DD")}~{moment(seasonInfo.noContractEnd).format("MM/DD")}까지 미사용 처리 가능
                                                        기간입니다.&nbsp;
                                                    </span>
                                                    해당 기간 이외에는 미사용 처리가 불가능 하오니, 반드시 기간 내에 미사용 처리를 진행해 주세요.
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {!isRecontractModal && (
                                <>
                                    <div className="div-table-contract">
                                        <div className="row mt-2 mb-3">
                                            <div className="col">
                                                <ContractTable.ModifyTable
                                                    tableId={"createTable"}
                                                    bizApp={bizAppMap}
                                                    serviceAppList={serviceAppList}
                                                    appAuthTypeList={appAuthTypeList}
                                                    list={contractList}
                                                    setList={updateContractList}
                                                    changeList={(_list) => {
                                                        updateContractList(_list);
                                                    }}
                                                    isRecontractSeason={seasonInfo && seasonInfo.isRecontractSeason}
                                                    isNoContractSeason={seasonInfo && seasonInfo.isNoContractSeason}
                                                    isRecontractModal={isRecontractModal}
                                                    seasonInfo={seasonInfo}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row m-3">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12" />
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                                            <button className="btn btn-info btn-rounded btn-block" onClick={() => submitContract(contractList)}>
                                                저장
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const RecontractStep = (props) => {
    const [currentStep, setCurrentStep] = useState(1);
    useEffect(() => {
        return () => {};
    }, [props.list]);

    return (
        <StepWizard initialStep={currentStep} isLazyMount={true}>
            <Step1 bizApp={props.bizApp} serviceAppList={props.serviceAppList} appAuthTypeList={props.appAuthTypeList} list={props.list} setList={props.setList} seasonInfo={props.seasonInfo} isRecontractModal={props.isRecontractModal} />
            <Step2 bizApp={props.bizApp} serviceAppList={props.serviceAppList} appAuthTypeList={props.appAuthTypeList} list={props.list} setList={props.setList} seasonInfo={props.seasonInfo} isRecontractModal={props.isRecontractModal} submitContract={props.submitContract} />
        </StepWizard>
    );
};

const Step1 = (props) => {
    useEffect(() => {
        return () => {};
    }, [props.list]);
    return (
        <>
            <div className="div-table-contract">
                <div className="row mt-3 mb-3">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <ol>
                            {props.seasonInfo && props.seasonInfo.isRecontractSeason && (
                                <>
                                    <li>
                                        <strong className="text-success">{props.seasonInfo.recontractYear}년 신규</strong>(
                                        <strong className="text-success">{props.seasonInfo.recontractYear - 1}년 6월 이후 계약</strong>) 계약을 제외한 기존 계약의 갱신을 진행하는 재계약 화면입니다.
                                    </li>
                                    <li>승인 연령과 수량 변경이 가능합니다.</li>
                                    <li>
                                        재계약 기본 적용 기간은 1년(<strong className="text-danger">~ {props.seasonInfo.recontractYear + 1}년 2월</strong>)입니다. 변경이 필요하시면 표의 하단에서 년도
                                        변경이 가능합니다.
                                    </li>
                                    <li>
                                        <strong className="text-danger">~ {moment(props.seasonInfo.recontractEnd).format("YYYY년 MM월 DD일")}</strong>까지 재계약 처리가 되지 않으면 서비스 이용이 자동
                                        중단되오니, 해당 기간 안에 재계약 처리를 반드시 진행하시기 바랍니다.
                                    </li>
                                </>
                            )}
                            {props.seasonInfo && props.seasonInfo.isNoContractSeason && (
                                <li>
                                    <span className="text-danger">
                                        {moment(props.seasonInfo.noContractStart).format("MM/DD")}~{moment(props.seasonInfo.noContractEnd).format("MM/DD")}까지 미사용 처리 가능 기간입니다.&nbsp;
                                    </span>
                                    해당 기간 이외에는 미사용 처리가 불가능 하오니, 반드시 기간 내에 미사용 처리를 진행해 주세요.
                                </li>
                            )}
                        </ol>
                    </div>
                </div>

                <div className="row mt-2 mb-5">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <ContractTable.ModifyTable
                            tableId={"createTable"}
                            bizApp={props.bizApp}
                            serviceAppList={props.serviceAppList}
                            appAuthTypeList={props.appAuthTypeList}
                            list={props.list}
                            setList={props.setList}
                            changeList={(_list) => {
                                _list.sort((a, b) => {
                                    return Number(a.age) - Number(b.age);
                                });
                                props.setList(_list);
                            }}
                            isRecontractSeason={props.seasonInfo && props.seasonInfo.isRecontractSeason}
                            isNoContractSeason={props.seasonInfo && props.seasonInfo.isNoContractSeason}
                            isRecontractModal={props.isRecontractModal}
                            seasonInfo={props.seasonInfo}
                        />
                    </div>
                </div>
            </div>

            <div className="row m-3">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12" />
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <button className="btn btn-primary" onClick={props.nextStep}>
                        다음 단계
                        <i className="fas fa-arrow-alt-circle-right ml-3" />
                    </button>
                </div>
            </div>
        </>
    );
};

const Step2 = (props) => {
    useEffect(() => {
        return () => {};
    }, [props.bizApp, props.list]);

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <h5 className="text-muted"> &lt;{props.seasonInfo.recontractYear} 계약 수량&gt;</h5>
                </div>
            </div>
            <div className="div-table-contract">
                <div className="row">
                    <div className="col">
                        <ContractTable.RecontractConfirmTable tableId={"createTable"} seasonInfo={props.seasonInfo} bizApp={props.bizApp} serviceAppList={props.serviceAppList} appAuthTypeList={props.appAuthTypeList} list={props.list} setList={props.setList} />
                    </div>
                </div>
            </div>
            <div className="row mt-2 text-center">
                <div className="col">
                    <h5 className="text-danger d-flex justify-content-center">위의 총 계약 수량을 확인하시고, 아래 계약 연장 버튼을 눌러 재계약 처리를 완료해 주세요.</h5>
                </div>
            </div>

            <div className="row m-3">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            props.previousStep();
                        }}
                    >
                        <i className="fas fa-arrow-alt-circle-left mr-3" />
                        이전 단계
                    </button>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <button className="btn btn-info btn-rounded btn-block" onClick={() => props.submitContract(props.contractList)}>
                        계약 연장 완료
                    </button>
                </div>
            </div>
        </>
    );
};

export default ModifyContractModal;
